import * as ActionTypes from './index';
import {actionCreator} from "../helpers/functions";

//action that changes the selected toba
export function changeSelectedToba(value) {
    return {
        type: ActionTypes.CHANGE_SELECTED_TOBA,
        payload: value
    }
}

//action that changes the advanced disbursements expense types form data
export function changeAdExpenseTypes(key, value, caseTypeId) {
    return {
        type: ActionTypes.CHANGE_AD_EXPENSE_TYPES,
        payload: {
            key,
            value,
			caseTypeId
		}
    }
}

//action that changes the advancedDisbursements form data
export function changeAdvancedDisbursementsFormData(payload) {
    return {
        type: ActionTypes.CHANGE_ADVANCED_DISBURSEMENTS_FORM_DATA,
        payload
    }
}

//action that updates the referToByCaseType property of the store
export function changeReferToByCaseType(caseTypeId, key, value) {
    return {
        type: ActionTypes.CHANGE_REFER_TO_BY_CASE_TYPE,
        payload: {
        	caseTypeId,
			key,
			value
		}
    }
}

//action that updates the referToBySubCaseType property of the store
export function changeReferToBySubCaseType(subCaseTypeId, key, value) {
    return {
        type: ActionTypes.CHANGE_REFER_TO_BY_SUB_CASE_TYPE,
        payload: {
        	subCaseTypeId,
			key,
			value
		}
    }
}

export function requestGetSolicitors() {
	return {
		type: ActionTypes.REQUEST_GET_SOLICITORS_SOLICITOR_GROUP
	}
}

export function receiveGetSolicitors(solicitors) {
	return {
		type: ActionTypes.RECEIVE_GET_SOLICITORS_SOLICITOR_GROUP,
		payload: solicitors
	}
}

//actions that requests the underwriters
export function requestGetUnderwriters() {
	return {
		type: ActionTypes.REQUEST_GET_UNDERWRITERS
	}
}

//action that receives the underwriters
export function receiveGetUnderwriters(underwriters) {
	return {
		type: ActionTypes.RECEIVE_GET_UNDERWRITERS,
		payload: underwriters
	}
}


//action that requests the work sources from the api
export function requestGetWorkSources() {
	return {
		type: ActionTypes.REQUEST_GET_WORK_SOURCES
	}
}

//action that receives the wok sources from the api
export function receiveGetWorkSources(workSources) {
	return {
		type: ActionTypes.RECEIVE_GET_WORK_SOURCES,
		payload: workSources
	}
}

//action that change the desired redux field
export function changeSolicitorGroupField(field, data){
	return {
		type: ActionTypes.CHANGE_SOLICITOR_GROUP_FIELD,
		payload : {
			key: field,
			value: data
		}
	}
}

//action that requests to post new solicitor group
export function requestPostSolicitorGroup(sendBody) {
	return {
		type: ActionTypes.REQUEST_POST_SOLICITOR_GROUP,
		payload: sendBody
	}
}

//action that receives post response
export function receivePostSolicitorGroupResponse(response) {
	return {
		type: ActionTypes.RECEIVE_POST_SOLICITOR_GROUP_RESPONSES,
		payload: response
	}
}

//action that receives created (status 201) response
export function createdSolicitorGroupResponse(response) {
	return {
		type: ActionTypes.CREATED_SOLICITOR_GROUP_RESPONSE ,
		payload: response
	}
}

//action that receives the bad request response of the post method to create new group
export function badRequestPostSolicitorGroup(badResponse) {
	return {
		type: ActionTypes.BAD_REQUEST_POST_SOLICITOR_GROUP,
		payload: badResponse
	}
}

//action that requests get the solicitor groups
export function requestGetSolicitorGroups(payload) {
	return {
		type: ActionTypes.REQUEST_GET_SOLICITOR_GROUPS,
		payload
	}
}

//action that receives the solicitor groups
export function receiveSolicitorGroups(payload) {
	return {
		type: ActionTypes.RECEIVE_SOLICITOR_GROUPS,
		payload
	}
}

//action that receives failed request fetching the solicitor groups
export function failedToGetSolicitorGroups(response) {
	return {
		type: ActionTypes.FAILED_TO_GET_SOLICITOR_GROUPS,
		payload: response
	}
}


//action that requests get the solicitor groups
export function requestGetSolicitorGroupsSuggestions(payload) {
	return {
		type: ActionTypes.REQUEST_GET_SOLICITOR_GROUPS_SUGGESTIONS,
		payload
	}
}

//action that receives the solicitor groups
export function receiveSolicitorGroupsSuggestions(payload) {
	return {
		type: ActionTypes.RECEIVE_SOLICITOR_GROUPS_SUGGESTIONS,
		payload
	}
}

export function receiveBadRequestSolicitorGroupsSuggestions(payload) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_SOLICITOR_GROUPS_SUGGESTIONS,
		payload
	}
}


//action that requests patch solicitor group
export function requestPatchSolicitorGroup(groupId,patchedGroup) {
	return {
		type: ActionTypes.REQUEST_PATCH_SOLICITOR_GROUP,
		payload: {
			key: groupId,
			value: patchedGroup
		}
	}
}

//action that receives patch solicitor group response
export function receivePatchSolicitorGroup(response){
	return {
		type: ActionTypes.RECEIVE_PATCH_SOLICITOR_GROUP,
		payload: response
	}
}

//action that receives failed response patch solicitor group
export function failedToPatchSolicitorGroup(response) {
    return {
        type: ActionTypes.FAILED_TO_PATCH_SOLICITOR_GROUP,
        payload: response
    }
}

//action that requests patch selected solicitor group
export function requestPatchSelectedSolicitorGroup(groupId,patchedGroup) {
	return {
		type: ActionTypes.REQUEST_PATCH_SELECTED_SOLICITOR_GROUP,
		payload: {
			key: groupId,
			value: patchedGroup
		}
	}
}


//action that receives patch selected solicitor group response
export function receivePatchSelectedSolicitorGroup(response){
	return {
		type: ActionTypes.RECEIVE_PATCH_SELECTED_SOLICITOR_GROUP,
		payload: response
	}
}

//action that receives bad request patch selected solicitor group response
export function badRequestPatchSelectedSolicitorGroup(response){
	return {
		type: ActionTypes.BAD_REQUEST_RECEIVE_PATCH_SELECTED_SOLICITOR_GROUP,
		payload: response
	}
}

//=====================================//
//action that requests get specific solicitor group EDIT
export function requestGetSpecificSolicitorGroupEdit(groupId) {
	return {
		type: ActionTypes.REQUEST_GET_SPECIFIC_SOLICITOR_GROUP_EDIT,
		payload: groupId
	}
}

export function receiveWorkSourcesEdit(groupId, worksources) {
	return {
		type: ActionTypes.RECEIVE_WORK_SOURCES_EDIT,
		payload: {
			groupId,
			worksources
		}
	}
}

//action that receives expenses in fetching solicitor cycle chain
export function receiveExpensesEdit(groupId, expenses) {
    return {
        type: ActionTypes.RECEIVE_EXPENSES_EDIT,
        payload: {
            groupId,
            expenses
        }
    }
}

export function receiveUnderwritersEdit(groupId, underwriters) {
	return {
		type: ActionTypes.RECEIVE_UNDERWRITERS_EDIT,
		payload: {
			groupId,
			underwriters
		}
	}
}

export function receiveSolicitorEdit(groupId, solicitors) {
	return {
		type: ActionTypes.RECEIVE_SOLICITOR_EDIT,
		payload: {
			groupId,
			solicitors
		}
	}
}

export function receiveCaseTypesEdit(groupId, caseTypes) {
	return {
		type: ActionTypes.RECEIVE_CASE_TYPE_EDIT,
		payload: {
			groupId,
			caseTypes
		}
	}
}

export const addSolicitorGroupUnderwriter = actionCreator(ActionTypes.ADD_SOLICITOR_GROUP_UNDERWRITER);

export const editSolicitorGroupUnderwriter = actionCreator(ActionTypes.EDIT_SOLICITOR_GROUP_UNDERWRITER);

export const removeSolicitorGroupUnderwriter = actionCreator(ActionTypes.REMOVE_SOLICITOR_GROUP_UNDERWRITER);


//action that requests a groups questions and the casetype, subcasetype they are visible in
export const getGroupQuestionsSpec = actionCreator(ActionTypes.GET_GROUP_QUESTIONS_SPEC);

export const getGroupQuestionsSpecSuccess = actionCreator(ActionTypes.GET_GROUP_QUESTIONS_SPEC_SUCCESS);

export const getGroupQuestionsSpecFailure = actionCreator(ActionTypes.GET_GROUP_QUESTIONS_SPEC_FAILURE);

//action that requests a groups questions and the casetype, subcasetype they are visible in
export const getGroupSpecDto = actionCreator(ActionTypes.GET_GROUP_SPEC_DTO);

export const getGroupSpecDtoSuccess = actionCreator(ActionTypes.GET_GROUP_SPEC_DTO_SUCCESS);

export const getGroupSpecDtoFailure = actionCreator(ActionTypes.GET_GROUP_SPEC_DTO_FAILURE);

